import { LegalLayout, LegalSection, LegalEntity } from "@/components/LegalLayout";
import { LEGAL } from "@/config/campaign";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung" testId="privacy-page">
      <p className="rounded-2xl border border-gold/40 bg-gold-dim p-4 text-sm text-gold-dark">
        Entwurf: Diese Datenschutzerklärung muss vor Livegang auf das Schweizer Datenschutzrecht (revDSG) abgestimmt und geprüft werden.
      </p>
      <LegalSection title="1. Verantwortliche Stelle">
        <p>Verantwortlich für die Datenbearbeitung auf chickenwinner.ch ist:</p>
        <LegalEntity />
      </LegalSection>
      <LegalSection title="2. Welche Daten wir erheben">
        <p>Im Rahmen der Wettbewerbsteilnahme erheben wir:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Vorname und Nachname</li>
          <li>E-Mail-Adresse</li>
          <li>Telefonnummer (Handynummer)</li>
          <li>Deine Einwilligungen inkl. Zeitpunkt (Consent-Historie)</li>
          <li>Kampagnen-Informationen (UTM-Parameter, Referrer), sofern vorhanden</li>
          <li>Technisch notwendige Daten (z. B. IP-Adresse zum Schutz vor Missbrauch)</li>
        </ul>
        <p>Wir erheben nur Daten, die für die Durchführung des Wettbewerbs benötigt werden (Datensparsamkeit).</p>
      </LegalSection>
      <LegalSection title="3. Zweck der Datenbearbeitung">
        <ul className="list-disc space-y-1 pl-5">
          <li>Durchführung des Wettbewerbs und Ermittlung der Gewinner</li>
          <li>Kontaktaufnahme im Gewinnfall (telefonisch und per E-Mail)</li>
          <li>Versand der Teilnahmebestätigung und des garantierten Sofortbonus (Steuer-Sparpaket 2027) per E-Mail</li>
          <li>Telefonische Kontaktaufnahme durch ChickenWinner.ch bzw. ausgewählte externe Dienstleister und Kooperationspartner (siehe Ziff. 5)</li>
          <li>ChickenWinner-Newsletter, sofern du dich separat und freiwillig dafür angemeldet hast</li>
        </ul>
      </LegalSection>
      <LegalSection title="4. Datenweitergabe zur Gewinnerabwicklung">
        <p>
          Die Durchführung der gewonnenen Steuererklärungs-Services erfolgt durch ausgewählte externe Dienstleister. Soweit du gewinnst, geben wir die dafür erforderlichen Daten an den entsprechenden Dienstleister weiter.
        </p>
      </LegalSection>
      <LegalSection title="5. Weitergabe an Partner und telefonische Kontaktaufnahme">
        <p>
          Mit der Teilnahme am Wettbewerb erklärst du dich einverstanden, dass die angegebenen Personendaten von ChickenWinner.ch verarbeitet und bei Bedarf an ausgewählte externe Dienstleister und Kooperationspartner, insbesondere aus den Bereichen Finanzen, Versicherungen, Vorsorge, Treuhand und Beratung, weitergegeben werden können.
        </p>
        <p>
          ChickenWinner.ch beziehungsweise entsprechende externe Dienstleister und Kooperationspartner dürfen dich telefonisch kontaktieren, insbesondere für Beratung, Informationen und passende Dienstleistungen. Diese Einwilligung kannst du jederzeit mit Wirkung für die Zukunft widerrufen, z. B. per E-Mail an {LEGAL.email}. Die bis zum Widerruf erfolgte Datenbearbeitung bleibt rechtmässig. Wir speichern den Zeitpunkt deiner Einwilligung nachvollziehbar (Consent-Historie).
        </p>
      </LegalSection>
      <LegalSection title="6. Empfänger und Dienstleister">
        <p>Für den Betrieb der Website setzen wir folgende Dienstleister ein:</p>
        <ul className="list-disc space-y-1 pl-5">
          <li>Hosting und Betrieb der Website: Emergent-Plattform (Cloud-Infrastruktur)</li>
          <li>Versand der Teilnahmebestätigung und des Sofortbonus: Resend (E-Mail-Versanddienst, über die Emergent-Plattform angebunden)</li>
        </ul>
        <p>Diese Dienstleister bearbeiten Daten ausschliesslich in unserem Auftrag.</p>
      </LegalSection>
      <LegalSection title="7. Speicherdauer">
        <p>Wir speichern deine Daten bis zum Abschluss des Wettbewerbs inklusive Gewinnerabwicklung und löschen sie anschliessend, sofern keine gesetzlichen Aufbewahrungspflichten bestehen und du keine darüber hinausgehende Einwilligung (z. B. Newsletter) erteilt hast.</p>
      </LegalSection>
      <LegalSection title="8. Deine Rechte">
        <p>
          Du hast im Rahmen des anwendbaren Rechts Anspruch auf Auskunft, Berichtigung, Löschung und Einschränkung der Bearbeitung deiner personenbezogenen Daten sowie auf Datenherausgabe. Erteilte Einwilligungen kannst du jederzeit widerrufen. Wende dich dazu an: {LEGAL.email}
        </p>
      </LegalSection>
      <LegalSection title="9. Datensicherheit">
        <p>Die Übertragung der Formulardaten erfolgt verschlüsselt (HTTPS). Die Daten werden serverseitig gespeichert und sind nicht öffentlich zugänglich.</p>
      </LegalSection>
    </LegalLayout>
  );
}
